"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*eslint-disable */
var _default = {
  name: 'LOCKED_SOLID',
  path: 'M15 11H9V7c0-1.7 1.3-3 3-3s3 1.3 3 3v4zm-3 7c-.8 0-1.5-.7-1.5-1.5S11.2 15 12 15s1.5.7 1.5 1.5S12.8 18 12 18zm5-7V7c0-2.8-2.2-5-5-5S7 4.2 7 7v4c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2z',
  viewBox: '0 0 24 24',
  invert: false
};
/*eslint-enable */

exports["default"] = _default;